import { makeStyles } from '@material-ui/core';
import logo from './herodevs-logo.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 30,
  },
});

// The HeroDevs wordmark for dark backgrounds; the sidebar is dark in both
// themes. Use the brand file as supplied, without recoloring it.
const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.img} src={logo} alt="" />;
};

export default LogoFull;
